import type { IIndustryCodesFilterDto } from "app/pages/sales-intelligence/domain/industry/types/filter-values";
import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";

const processIndustryCodesFilter = (
    filterDtos: readonly IIndustryCodesFilterDto[],
): ReadonlyArray<keyof LeadsSearchRow> => {
    const columns = new Set<keyof LeadsSearchRow>();

    filterDtos.forEach((filterDto) => {
        if (filterDto.naicsCodes.length > 0) {
            columns.add("naics_codes");
        }

        if (filterDto.sicCodes.length > 0) {
            columns.add("sic_codes");
        }
    });

    return Array.from(columns);
};

export default processIndustryCodesFilter;
